declare const brandKey: unique symbol;

type Brand<T, B extends string> = T & { readonly [brandKey]: B };

export type ProjectId = Brand<string, "ProjectId">;
export type SourceId = Brand<string, "SourceId">;
export type TrackId = Brand<string, "TrackId">;
export type ClipId = Brand<string, "ClipId">;
export type OpId = Brand<string, "OpId">;

/** Injected so that document-building code stays deterministic under test. */
export type IdFactory = () => string;

export const randomId: IdFactory = () => crypto.randomUUID();

export const asProjectId = (value: string): ProjectId => value as ProjectId;
export const asSourceId = (value: string): SourceId => value as SourceId;
export const asTrackId = (value: string): TrackId => value as TrackId;
export const asClipId = (value: string): ClipId => value as ClipId;
export const asOpId = (value: string): OpId => value as OpId;
